<script>
export const group = 'Full'
</script>

<script setup>
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import MysterySoundGuess from '../screens_qmusic_nl_default/MysterySoundGuess.vue'
import MysterySoundGuessBackground from '../../../assets/images/mystery_sound_guess_background.png'

defineProps({
  item: Object,
})
</script>

<template>
  <ToFullBottomRight>
    <MysterySoundGuess :key="item.id" :item="item" />
    <img :src="MysterySoundGuessBackground" class="size-full" />
  </ToFullBottomRight>
</template>
